// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"signInPage_innerContainer__2pNsz","title":"signInPage_title__2we9W","signInForm":"signInPage_signInForm__3ehQ-","nameInput":"signInPage_nameInput__cHqLz"};